module.exports = __webpack_public_path__ + "static/media/nilo_castro_dos_santos.34a64a5c.jpg";